import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function mijnDossierReducer(state = initialState.mijnDossier, action) {
	switch (action.type) {
		case types.MIJN_DOSSIER_LOADED: {
			return Object.assign(
                {}, 
                state,
                action.body
            );
		}
		default:
			return state;
	}
}